export namespace PromiseHelper {
    export async function delay(timeout: number) {
      await new Promise<void>((resolve: any) => window.setTimeout(resolve, timeout));
    }

    export async function setTimeout<T>(action: () => Promise<T>, timeout: number, callback?: () => {}): Promise<T> {
      return new Promise(async (resolve, reject) => {
        let error;

        let timer = window.setTimeout(() => {
          error = new Error('Operation timed out.');
          reject(error);
          if (callback) callback();
        }, timeout);

        try {
          const result = await action();

          if (!error) {
            window.clearTimeout(timer);
            resolve(result);
          }
        }
        catch (err) {
          window.clearTimeout(timer);
          reject(err);
        }
      });
    }
}
